// extracted by mini-css-extract-plugin
export default {"trainAwsPdApplication":"styles_trainAwsPdApplication__VD49T","iframeContainer":"styles_iframeContainer__MUL16"};